import { Fab, styled } from '@mui/material'
import { Icon } from 'packages/eid-icons'

const StyledFab = styled(Fab)((props) => ({
    textTransform: 'capitalize',
    fontSize: '14px',
    height: '31px !important',
    margin: '8px 0px !important',
    width: '100% !important',
    backgroundColor: '#f7f8fa ',
    color: '#ff4d5f',
    boxShadow: 'none',
    overflowWrap: 'anywhere',
    lineHeight: 1.2,
    border: '1px solid #ff4d5f',
    '& svg': {
        position: 'absolute',
        left: '12px',
        color: '#ff4d5f',
        top: '50%',
        transform: ' translateY(-50%) rotate(-180deg)',
    },
    '&:hover': {
        backgroundColor: '#f7f8fa',
    },

    ...props.styles,
    '&.Mui-disabled': {
        backgroundColor: '#f7f8fa !important',
        border: '1px solid #8b909a !important',

        color: '#8b909a !important',
        '& svg': {
            color: '#8b909a !important',
        },
    },
}))

const RemoveAllButton = ({
    styles,
    active,
    iconName,
    startIcon,
    children,
    activeStyle,
    ...rest
}) => {
    return (
        <StyledFab variant="extended" size="small" styles={styles} {...rest}>
            {startIcon && (
                <Icon
                    name={iconName ? iconName : 'ArrowSmall'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
            {children}

            {!startIcon && (
                <Icon
                    name={iconName ? iconName : 'ArrowSmall'}
                    color={styles?.color ? styles.color : '#ffffff'}
                ></Icon>
            )}
        </StyledFab>
    )
}

export default RemoveAllButton
